// Contact.jsx
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Contact.css";
import base_url from "../../api"; // adjust path to your base_url

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        setLoggedInUser(user);
        setFormData((prev) => ({
          ...prev,
          name: user.name || "",
          email: user.email || "",
          phone: user.phone || "",
        }));
      } catch (err) {
        console.error("Error parsing stored user:", err);
      }
    }
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Clear error for this field when user starts typing
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validatePhone = (phone) => {
    if (!phone.trim()) {
      return "Phone number is required";
    }
    const digitsOnly = phone.replace(/\D/g, "");
    if (digitsOnly.length < 10 || digitsOnly.length > 15) {
      return "Phone number must be between 10 and 15 digits";
    }
    return "";
  };

  const validateEmail = (email) => {
    if (!email.trim()) {
      return "Email is required";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      return "Please enter a valid email address";
    }
    return "";
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!loggedInUser) {
    toast.warn("Please login first to send a message.");
    return;
  }

  // Validate all fields and set errors
  const newErrors = {};
  let hasErrors = false;

  if (!formData.name.trim()) {
    newErrors.name = "Name is required.";
    hasErrors = true;
  }

  const emailError = validateEmail(formData.email);
  if (emailError) {
    newErrors.email = emailError;
    hasErrors = true;
  }

  const phoneError = validatePhone(formData.phone);
  if (phoneError) {
    newErrors.phone = phoneError;
    hasErrors = true;
  }

  if (!formData.message.trim()) {
    newErrors.message = "Message cannot be empty.";
    hasErrors = true;
  } else if (formData.message.trim().length < 10) {
    newErrors.message = "Message must be at least 10 characters long.";
    hasErrors = true;
  }

  if (hasErrors) {
    setErrors(newErrors);
    toast.error("Please fix the errors in the form", { position: "top-right" });
    return;
  }

  setErrors({});

  try {
    const token = localStorage.getItem("token");

    if (!token) {
      toast.warn("Session expired. Please log in again.");
      return;
    }

    const response = await fetch(`${base_url}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // ✅ include token in header
      },
      body: JSON.stringify({ message: formData.message }),
    });

    const result = await response.json();

    if (response.ok) {
      toast.success(result.message || "Message sent successfully!");
      setFormData((prev) => ({ ...prev, message: "" }));
    } else {
      toast.error(result.message || "Failed to send message.");
    }
  } catch (err) {
    console.error(err);
    toast.error("Server error, please try again later.");
  }
};

  const isDisabled = !loggedInUser;

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <p>We’d love to hear from you! Please fill out the form below.</p>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            name="name"
            placeholder={isDisabled ? "Login to write here..." : "Full Name"}
            value={formData.name}
            onChange={handleChange}
            disabled={isDisabled}
            required
            className={errors.name ? "error-input" : ""}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div>
          <input
            type="email"
            name="email"
            placeholder={isDisabled ? "Login to write here..." : "Email Address"}
            value={formData.email}
            onChange={handleChange}
            disabled={isDisabled}
            required
            className={errors.email ? "error-input" : ""}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div>
          <input
            type="tel"
            name="phone"
            placeholder={isDisabled ? "Login to write here..." : "Phone Number"}
            value={formData.phone}
            onChange={handleChange}
            disabled={isDisabled}
            required
            className={errors.phone ? "error-input" : ""}
          />
          {errors.phone && <span className="error-message">{errors.phone}</span>}
        </div>

        <div>
          <textarea
            name="message"
            placeholder={isDisabled ? "Login to write here..." : "Your Message"}
            rows="5"
            value={formData.message}
            onChange={handleChange}
            disabled={isDisabled}
            required
            className={errors.message ? "error-input" : ""}
          />
          {errors.message && <span className="error-message">{errors.message}</span>}
        </div>

        <button type="submit" disabled={isDisabled}>
          {isDisabled ? "Login to send" : "Send Message"}
        </button>
      </form>

      <ToastContainer position="top-right" autoClose={2000} />
    </div>
  );
};

export default Contact;
